import { Moment } from 'moment';
import React from 'react';
import { useAppContext } from '../../../../Services/AppContext';
import { getMomentDate } from '../../../../Utils/dates.util';

export enum DateFormat {
	DATE = 'date',
	TIME = 'time',
	DATE_TIME = 'dateTime',
}

interface Props {
	date: string | Moment;
	format: DateFormat;
}

const FormattedMomentDate: React.FC<Props> = ({ date, format }) => {
	const { dateFormatMoment } = useAppContext();
	const dateInMoment = getMomentDate(date);

	let formattedDate: string;

	switch (format) {
		case DateFormat.DATE:
			formattedDate = dateInMoment.format(dateFormatMoment);
			break;
		case DateFormat.TIME:
			formattedDate = dateInMoment.format('HH:mm');
			break;
		case DateFormat.DATE_TIME:
			formattedDate = dateInMoment.format(dateFormatMoment + ', HH:mm');
			break;
	}

	return <>{formattedDate}</>;
};

export default FormattedMomentDate;
